module.exports = __webpack_public_path__ + "static/redsneakers-0061719231aefc8a0fd1667f5f308826.png";